import { StaticImage } from 'gatsby-plugin-image';
import React, { FC } from 'react';

import { PanelLarge } from '../shared/PanelLarge';
import { NavigateUnexpectedProps } from '.';
import { body, heading } from './content';

interface NavigateUnexpectedLargeProps extends NavigateUnexpectedProps {}

export const NavigateUnexpectedLarge: FC<NavigateUnexpectedLargeProps> = ({
  bodyTextReplacement,
}) => (
  <PanelLarge
    image={<StaticImage src="../images/chat.webp" alt="advisor" />}
    imageAlignment="right"
    body={bodyTextReplacement || body}
    heading={heading}
    spacing={242}
  />
);
